var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 3.33341V13.3334C6.6665 13.7754 6.8421 14.1994 7.15466 14.5119C7.46722 14.8245 7.89114 15.0001 8.33317 15.0001H14.9998C15.4419 15.0001 15.8658 14.8245 16.1783 14.5119C16.4909 14.1994 16.6665 13.7754 16.6665 13.3334V6.03508C16.6665 5.81305 16.6221 5.59326 16.5359 5.38862C16.4498 5.18398 16.3236 4.99862 16.1648 4.84341L13.4023 2.14175C13.091 1.8373 12.6728 1.6668 12.2373 1.66675H8.33317C7.89114 1.66675 7.46722 1.84234 7.15466 2.1549C6.8421 2.46746 6.6665 2.89139 6.6665 3.33341V3.33341Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 15.0002V16.6668C13.3333 17.1089 13.1577 17.5328 12.8451 17.8453C12.5325 18.1579 12.1086 18.3335 11.6666 18.3335H4.99992C4.55789 18.3335 4.13397 18.1579 3.82141 17.8453C3.50885 17.5328 3.33325 17.1089 3.33325 16.6668V7.50016C3.33325 7.05814 3.50885 6.63421 3.82141 6.32165C4.13397 6.00909 4.55789 5.8335 4.99992 5.8335H6.66659",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy2.46c1f190.svg";
export { ForwardRef as ReactComponent };